import { Link, useParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api, formatINR } from "../lib/api";
import { format } from "date-fns";

export default function OrderSuccess() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  useEffect(() => {
    api.get(`/orders/${id}`).then(({ data }) => setOrder(data)).catch(() => {});
  }, [id]);

  return (
    <div className="App">
      <Navbar />
      <div className="mx-auto max-w-3xl px-6 py-24 text-center" data-testid="order-success-page">
        <CheckCircle2 className="mx-auto h-16 w-16 text-[#9ead94]" />
        <p className="label-tiny mt-6">Order confirmed</p>
        <h1 className="mt-4 font-serif text-4xl text-[#2a2928] sm:text-5xl">Thank you.</h1>
        <p className="mt-4 text-[#7a7571]">
          We&apos;ve received your order. You&apos;ll get a confirmation on email shortly.
        </p>
        {order && (
          <div className="mt-10 rounded-3xl border border-[#e8e2da] bg-white p-8 text-left" data-testid="order-success-summary">
            <div className="flex flex-wrap justify-between gap-2">
              <div className="font-serif text-2xl">{order.order_number}</div>
              <div className="font-serif text-2xl text-[#d08c8c]">{formatINR(order.total)}</div>
            </div>
            <div className="mt-2 text-sm text-[#7a7571]">
              Delivery: {order.recipient_name} on {format(new Date(order.delivery_date), "PPP")} · {order.delivery_slot}
            </div>
            <div className="mt-6 space-y-2">
              {order.items.map((it) => (
                <div key={it.product_id} className="flex justify-between text-sm">
                  <span>{it.name} × {it.quantity}</span>
                  <span>{formatINR(it.line_total)}</span>
                </div>
              ))}
            </div>
          </div>
        )}
        <div className="mt-8 flex justify-center gap-3">
          <Link
            to="/shop"
            data-testid="order-success-shop-more"
            className="rounded-full border border-[#e8e2da] bg-white px-6 py-3 text-sm font-medium hover:border-[#d08c8c]"
          >
            Shop more
          </Link>
          <Link
            to="/account"
            data-testid="order-success-view-orders"
            className="rounded-full bg-[#d08c8c] px-6 py-3 text-sm font-medium text-white hover:bg-[#b87a7a]"
          >
            View my orders
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
